// src/tab/tab-context.ts
import { createContext } from "react";
var TabContext = createContext(void 0);

export {
  TabContext
};
